import React from "react";
import { PreviewLoadingOverlay } from "../../components/LoadingStates";
import { MOBILE_PREVIEW_WIDTH, PreviewDevice } from "../../components/usePreviewPlayer";

interface Props {
  iframeRef: React.RefObject<HTMLIFrameElement>;
  iframeSrc: string;
  pageUrl: string;
  previewDevice: PreviewDevice;
  isLoading: boolean;
  previewPlayerName?: string;
}

const ReviewPagePreview: React.FC<Props> = ({
  iframeRef,
  iframeSrc,
  pageUrl,
  previewDevice,
  isLoading,
  previewPlayerName,
}) => {
  const isMobilePreview = previewDevice === "mobile";

  return (
    <div className="min-w-0 w-full overflow-hidden rounded-xl border border-slate-200 bg-slate-50">
      <div className="flex items-center gap-3 border-b border-slate-200 bg-slate-100 px-3 py-2">
        <div className="flex gap-1.5" aria-hidden>
          <span className="size-2.5 rounded-full bg-slate-300" />
          <span className="size-2.5 rounded-full bg-slate-300" />
          <span className="size-2.5 rounded-full bg-slate-300" />
        </div>
        <div className="min-w-0 flex-1 truncate rounded-md bg-white px-3 py-1 text-xs text-slate-500">{pageUrl}</div>
      </div>

      <div className="relative h-[calc(100vh-18rem)] min-h-[32rem] w-full overflow-hidden bg-white lg:h-[calc(100dvh-200px)] lg:min-h-80">
        <iframe
          ref={iframeRef}
          title="Reviews Page preview"
          src={iframeSrc}
          className={`mx-auto block h-full border-0 bg-white ${isMobilePreview ? "max-w-full" : "w-full"}`}
          style={isMobilePreview ? { width: MOBILE_PREVIEW_WIDTH } : undefined}
        />
        {isLoading && <PreviewLoadingOverlay playerName={previewPlayerName} />}
      </div>
    </div>
  );
};

export { ReviewPagePreview };
